import Home from './Home.data-manager-bet365.vue'

export default {
  Home
}